import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App history={ window.location } />, document.getElementById('root'));

serviceWorker.unregister();
